import {message} from 'antd';
import dayjs from 'dayjs'
import React, {useContext, useState} from 'react'
import { FormMode } from 'common/util/Util.tsx'

export interface AppContextType {
    parentAdvertiserId: number | undefined;
    setParentAdvertiserId: (id: number | undefined) => void;
    backToAdGroupId: number | undefined;
    setBackToAdGroupId: (id: number | undefined) => void;
    backToAdGroupMode: FormMode | undefined;
    setBackToAdGroupMode: (id: FormMode | undefined) => void;
    creativeIdToLink: number | undefined;
    setCreativeIdToLink: (id: number | undefined) => void;
    campaignIdToLink: number | undefined;
    setCampaignIdToLink: (id: number | undefined) => void;
    filterByAdGroupId: number | undefined;
    setFilterByAdGroupId: (id: number | undefined) => void;
    preloader: boolean;
    setPreloader: (value: boolean) => void;
    messageApi: any;
    contextHolder: any;
    error?: string;
    setError: (error?: string) => void;
    dictionaries: Map<string, Array<any>>;
    listFilters?: Map<string, ListFilters>
    setListFilters: (value:Map<string, ListFilters>) => void;
    pendingListNavigation?: Map<string, PendingListNavigation>;
    setPendingListNavigation: (value: Map<string, PendingListNavigation>) => void;
}

export interface PendingListNavigation {
    repositionByModifiedDate?: boolean;
}

export interface ListFilters {
    page: number
    pageSize: number
    sort?: {
        name: string
        direction: 'asc' | 'desc'
    }
    name?: string
    status?: string
    active?: boolean
    format?: string
    interfaceId?: string
    agencyId?: number
    accountId?: number
    advertiserId?: number
    campaignId?: number
    adGroupId?: number
    creativeId?: number
    retargetingListId?: number
    siteId?: number
    publisherId?: number
    filterListId?: number
    type?: string
    startInterval?: dayjs.Dayjs
    endInterval?: dayjs.Dayjs
    daysLeft?: dayjs.Dayjs
    sspType?: string
    requestType?: string
    ownedBy?: string
    trusted?: boolean
    role?: string
    pageUrlSearch?: string
    keywordSearch?: string
    brandSafetySearch?: string
}

const AppContext = React.createContext<AppContextType | undefined>(undefined);

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};

export const AppProvider = ({children}) => {
    const [parentAdvertiserId, setParentAdvertiserId] = useState<number | undefined>();
    const [backToAdGroupId, setBackToAdGroupId] = useState<number | undefined>();
    const [backToAdGroupMode, setBackToAdGroupMode] = useState<FormMode | undefined>();
    const [creativeIdToLink, setCreativeIdToLink] = useState<number | undefined>();
    const [campaignIdToLink, setCampaignIdToLink] = useState<number | undefined>();
    const [filterByAdGroupId, setFilterByAdGroupId] = useState<number | undefined>();
    const [preloader, setPreloader] = useState(false)
    const [error, setError] = useState<string>()
    const [messageApi, contextHolder] = message.useMessage();
    const dictionaries = new Map<string, Array<any>>()
    const [listFilters, setListFilters] = useState(new Map<string, ListFilters>())
    const [pendingListNavigation, setPendingListNavigation] = useState(new Map<string, PendingListNavigation>())

    return (
        <AppContext.Provider value={
            {
                parentAdvertiserId,
                setParentAdvertiserId,
                backToAdGroupId,
                setBackToAdGroupId,
                backToAdGroupMode,
                setBackToAdGroupMode,
                creativeIdToLink,
                setCreativeIdToLink,
                campaignIdToLink,
                setCampaignIdToLink,
                filterByAdGroupId,
                setFilterByAdGroupId,
                preloader,
                setPreloader,
                messageApi,
                contextHolder,
                error,
                setError,
                dictionaries,
                listFilters,
                setListFilters,
                pendingListNavigation,
                setPendingListNavigation
            }
        }>
            {children}
        </AppContext.Provider>
    );
};

export default AppProvider
